import { BatchesService } from '@festina/lifedatareplicator-general-types/lifedatareplicator/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServiceDeleteDelete
type MethodParam = Parameters<typeof method>[0]

export const useDeleteLifeDataReplicatorBatch = () =>
  useFestinaMutation({
    component: 'lifeDataReplicator',
    isScenario: false,
    roles: BatchesService.batchesServiceDeleteDelete_roles,
    mutateFunction: async (arg: MethodParam) => await method(arg),
  })
